import React, { useState, useEffect } from 'react';
import Header from '../components/layout/Header';
import PageHeader from "../components/layout/PageHeader";
import { Footer } from '../components/layout/Footer';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useHistory } from 'react-router-dom';

 const ChangePassword = () => {
    const [validated, setValidated] = useState(false)
    const [password, setPassword] = React.useState('')
    const history = useHistory()
    const auth=sessionStorage.getItem('user')
    useEffect( () => {
        if(auth){
            history.push(process.env.PUBLIC_URL+'/');
        }
    });
    const handleSubmit = (event) => {
        const form = event.currentTarget
        if (form.checkValidity() === false) {
        event.preventDefault()
        event.stopPropagation()
        }
        setValidated(true)
        const api_url=process.env.REACT_APP_API_URL
        if((password !== '') ){
            const email=sessionStorage.getItem('fps');
            const formData = new FormData()
            formData.append("email",email)
            formData.append("password",password)
            const result=fetch(api_url + 'user/change_password', {
                method: 'POST',
                body: formData,
            })
            .then(response=>response.json())
            .then(result=> {
                if(result.status === true){
                    sessionStorage.clear();
                    // sessionStorage.removeItem('fps');
                    alert(result.message+' successfully!!')
                    
                }else{
                    sessionStorage.clear();
                    // sessionStorage.removeItem('fps');
                    alert(result.error+"!!")
                }
                history.push(process.env.PUBLIC_URL+'/login')
            })
        }else{
            alert('please enter password!!');
        }
    }
        return (
            <>
                <div className="site-main">
                    <Header/>
                
                    {/* PageHeader */} 
                    <PageHeader
                        title="Add New Password"
                        breadcrumb="Change Password"
                    />
                    {/* PageHeader end */}


                    {/* login */}
                    <div className="ttm-row login-section clearfix p-2">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 mx-auto">
                                    <div className="bg-theme-GreyColor ttm-col-bgcolor-yes ttm-bg rounded p-10 p-lg-20">
                                        <div className="ttm-col-wrapper-bg-layer ttm-bg-layer"></div>
                                        <div className="layer-content">
                                            <div className="ttm-tabs ttm-tab-style-02">
                                                <Tabs>
                                                    <TabList className="tabs">
                                                        <Tab className="tab">
                                                            <div style={{textAlign:'center'}}>
                                                            <img src={process.env.PUBLIC_URL+'/images/web/changep.png'} style={{height:'250px'}}/>
                                                            <p>Make it more secure</p>
                                                            </div>
                                                               
                                                        </Tab>
                                                    </TabList> 
                                                    <div className="content-tab">
                                                        <TabPanel>
                                                            <form id="login_form" className="login_form wrap-form">
                                                                <div className="row">
                                                                    <div className="col-lg-12">
                                                                        <label>
                                                                            <i className="ti ti-lock"></i>
                                                                            <input type="password" id="txtemail" onChange={(e)=>{ setPassword(e.target.value);}} placeholder="Enter Your New Password here" />
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-lg-6 mx-auto">
                                                                        <label className="mb-0">
                                                                            <button className="submit w-100 ttm-btn ttm-btn-size-md ttm-btn-shape-rounded ttm-btn-style-fill ttm-btn-color-skincolor" type="button" onClick={handleSubmit}>NEXT</button>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </TabPanel>
                                                    </div>       
                                                </Tabs>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    {/* login end */}

                    
                <Footer/>
            </>
          )
   }

export default ChangePassword;